import { PaginationModel } from '../../utils/pagination';
import {
  Action,
  getModule,
  Module,
  Mutation,
  VuexModule,
} from 'vuex-module-decorators';
import store from '@/store';
import { ErrorResponse } from '@/utils/response';
import { axios, CustomAxiosResponse } from '@/utils/axios';
import { PaperGeneratedItem } from './paper-generated-item.model';
import { PaperGenerated } from '../paper-generated/paper-generated.model';

export interface PaperGeneratedItemStoreInterface {
  paperGeneratedItems: PaperGeneratedItem[];
  error: ErrorResponse | null;
  pagination: PaginationModel;
  pdfFile: any | null;
  fetchPaperGeneratedItems(paperGenerated: PaperGenerated): Promise<void>;
  createPdf(paperGenerated: PaperGenerated): Promise<void>;
}

@Module({
  namespaced: true,
  dynamic: true,
  name: 'paper-generated-item',
  store,
})
class PaperGeneratedItemStore extends VuexModule {
  paperGeneratedItems: PaperGeneratedItem[] = [];
  error: ErrorResponse | null = null;
  pagination = { ...this.defaultPagination };
  pdfFile: any | null = null;

  get defaultPagination(): PaginationModel {
    return {
      page: 1,
      limit: 6,
      totalPages: 1,
      totalRecords: 1,
      isResetPage: false,
    };
  }

  @Mutation
  updateCollectionItems(params: PaperGeneratedItem[]) {
    if (this.paperGeneratedItems.length === 0 || this.pagination.isResetPage) {
      this.paperGeneratedItems = params;
      this.pagination.isResetPage = false;
    } else {
      this.paperGeneratedItems.push(...params);
    }
  }

  @Mutation
  resetPagination() {
    this.pagination = {
      page: 1,
      limit: 6,
      totalPages: 1,
      totalRecords: 1,
      isResetPage: false,
    };
  }

  @Mutation
  setError(params: ErrorResponse) {
    this.error = params;
  }

  @Mutation
  updatePagination(params: PaginationModel) {
    this.pagination = params;
  }

  @Mutation
  updatePdfFile(params: any) {
    this.pdfFile = params;
  }

  @Action
  async fetchPaperGeneratedItems(
    paperGenerated: PaperGenerated,
  ): Promise<void> {
    this.context.commit('updateCollectionItems', []);
    this.context.commit('setError', null);

    const query = `page=${this.pagination.page}&limit=${this.pagination.limit}`;

    try {
      const { data, pagination }: CustomAxiosResponse = await axios.get(
        `paper-generated/${paperGenerated.id}/paper-generated-item/pagination?${query}`,
      );

      this.context.commit('updateCollectionItems', data);
      this.context.commit('updatePagination', pagination);
    } catch (error) {
      this.context.commit('setError', error);
    }
  }

  @Action
  async createPdf(paperGenerated: PaperGenerated): Promise<void> {
    this.context.commit('updatePdfFile', null);
    this.context.commit('setError', null);

    try {
      const { data }: CustomAxiosResponse = await axios.post(
        `/paper-generated/${paperGenerated.id}/pdf`,
        {},
        { responseType: 'arraybuffer' },
      );

      this.context.commit('updatePdfFile', data);
    } catch (error) {
      this.context.commit('setError', error);
    }
  }
}

export default getModule(PaperGeneratedItemStore);
